<script>
    import { required, minLength, numeric } from "vuelidate/lib/validators";
    import General from '@/services/General';
    import Customers from '@/services/Customers';
    import validationMessages from '@/components/validations'

    export default {
        components:{
            validationMessages
        },
        props: {
            phoneData: {
                type: Object,
                default: null
            },
        },
        watch: {
            phoneData: function(newVal) {
                this.id_e = newVal.phone_id;
                this.phone_raw_e = newVal.phone_raw;
                this.phone_formatted_e = newVal.phone_formatted;
                this.phone_country_e = newVal.phone_country;
                this.primary_e = newVal.primary;
                this.phone_type_e = newVal.phone_type;
                this.phoneBase()
                this.checked_primary()
            }
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                id_e: '',
                phone_raw_e: '',
                phone_country_e: '',
                phone_formatted_e: '',
                primary_e: '',
                phone_type_e: '',
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                countries: {},
                prefix: '',
                splitedPhoneStr: '',
                phone_number: '',
                primary_checked: false,
            };
        },
        validations: {
            phone_number: {
                required,
                minLength: minLength(2),
                numeric
            },
        },
        created() {
            this.getCountry()
        },
        methods: {

            async editCustomerPhone(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {
                    try {

                        await Customers.updatePhone(this.id_e,{
                            phone_raw: this.phone_number,
                            phone_country: this.phone_country_e,
                            phone_type: this.phone_type_e,
                            primary: this.primary_checked == true ? 'Y' : 'N',
                            csrf_token: this.csrf_token
                        }).then((response) => {
                            this.successmsg("Changes has been saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg("Changes not saved")
                        }).finally(() => {
                            this.refreshData()
                            this.tryingToEdit = false;
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg("Changes not saved")
                    }
                }
                this.tryingToEdit = false;
            },

            phoneBase(){
                if(this.phone_country_e){
                    this.splitedPhoneStr = this.phone_formatted_e.split(" ");
                    this.splitedPhoneStr.shift();
                    this.phone_number = this.splitedPhoneStr.join('');
                }else{
                    this.phone_number = this.phone_raw_e;
                }
            },
            checked_primary(){
                this.primary_checked = this.primary_e == 'Y' ? true : false;
            },
            refreshData() {
                this.$emit('onRefresh') //event from parent
            },

            async getCountry() {
                try {
                    await General.getCountry({

                    }).then((response) => {
                        this.countries = response.data;
                    }).catch(error => {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg("Can not get countries")
                    }).finally(() => {
                    })

                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.failedmsg("Can not get countries")
                }
            },

            closeModal() {
                this.showModal = false;
            },
        }
    };
</script>

<template>
    <b-modal v-model="showModal" id="phone_edit" title="Edit Customer Phone" title-class="font-18" centered>
        <form @submit.prevent="editCustomerPhone">
            <label>Phone Number</label>
            <b-input-group class="mb-3">
                <select v-model="phone_country_e" class="form-select">
                    <option v-for="country in countries" :key="country.alpha2code" :value="country.alpha2code">{{country.alpha2code}} ({{country.calling_code}})</option>
                </select>
                <b-input-group-append>
                <b-form-group label-for="formrow-phone-input" >
                    <b-form-input
                            v-model.trim="phone_number"
                            type="text"
                            id="phone"
                            aria-describedby="order-feedback"
                            :class="{
                              'is-invalid': submitted && $v.phone_number.$error,
                            }"
                    >
                    </b-form-input>
                    <validationMessages v-if="submitted" :fieldName="'Phone'" :validationName="$v.phone_number"></validationMessages>
                </b-form-group>
                </b-input-group-append>
            </b-input-group>

            <b-form-group label="Phone Type" label-for="formrow-phone_type-input" class="mb-3">
                <select v-model="phone_type_e" class="form-select">
                    <option value="mobile">Mobile</option>
                    <option value="fixed">Fixed</option>
                </select>
            </b-form-group>

            <b-form-checkbox-group>.
                <div class="form-check form-switch form-switch-lg mb-3" >
                    <input v-model="primary_checked"
                            type="checkbox"
                            class="form-check-input"
                            id="primaryPhone"
                    />
                    <label class="form-check-label" for="primaryPhone">Primary Phone</label>
                </div>
            </b-form-checkbox-group>
            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="editCustomerPhone" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Change</b-button>
        </template>
    </b-modal>
</template>